import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
    ImageGlobalUrl,
} from "../../../lib/constant";
import { Notification } from "../../../lib/Notification";
import HappyFaceIcon from "../../../icons/happyFaceIcon";
import FilledCheckIcon from "../../../icons/FilledCheckBox";

const AccessLinkPage = ({
    show,
    onHide,
    uniqueCode,
    productSummary
}) => {
    const copyUrl = `${window.location.origin}/project/${uniqueCode}`
    const [linkCopy, setLinkCopy] = useState(false)
    const copyLink = () => {
        var text = copyUrl
        var elem = document.createElement("textarea");
        document.body.appendChild(elem);
        elem.value = text;
        elem.select();
        document.execCommand("copy");
        document.body.removeChild(elem);
        toast.success(Notification['Copy Link'])
        setLinkCopy(true)
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            className="project-saved-modal"
        >
            <Modal.Header closeButton></Modal.Header>
            {uniqueCode && <Modal.Body className="w-[74%]">
                <div>
                    <div className="text-center">
                        <div className="flex justify-center">
                            <HappyFaceIcon />
                        </div>
                        <h2 className="mb-2 pt-2 mt-3">Your Project is saved!</h2>
                        <h5 className="sub-title mb-5">
                            Use this link to access your project.
                        </h5>
                    </div>
                    <div className=" w-100">
                        <div className="mb-3 d-flex align-items-center flex-wrap">
                            <label  className="w-100  me-2 label-input flex-1" >
                                <input
                                    type="text"
                                    name="name"
                                    className="w-100 copy-link"
                                    value={copyUrl}
                                    readOnly
                                />
                            </label>
                            <button className="btn btn-outline-primary " onClick={() => copyLink()}>{linkCopy ? 'Copied!' : 'Copy'}</button>
                        </div>
                    </div>
                    <div className="text-center">
                        <a
                            href={copyUrl}
                            target='_blank'
                            className="mt-2 mb-3 text-5 leading-5 preview-link text-dark font-bold"
                            rel="noreferrer"
                        >
                            Hey ! Check your preview link
                        </a>
                    </div>
                    <div className="text-center mt-3 pt-2">
                        <div className="row">
                            {productSummary?.productSummary?.map((image, index) => {
                                return <div className="col-3" key={index}>
                                    <img
                                        src={`${ImageGlobalUrl}/${image?.base64Image}`}
                                        key={image?.base64Image}
                                        alt=""
                                        className="img-fluid "
                                    />
                                </div>
                            })}
                        </div>
                    </div>
                 
                    <div className="flex flex-col items-center gap-2 mt-5">
                        <div className="flex items-center gap-2">
                            <FilledCheckIcon />
                            <div className="font-inter font-medium text-5 leading-5 text-center text-gray-500">
                                Project saved successfully! Please check your mail.
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            }
        </Modal>
    )
}

export default AccessLinkPage